<template>
  <MarketplaceCard
    v-if="zapierIntegrations"
    v-model="zapierIntegrations.zapier.enabled"
    :logo-path="imageUrl"
    logo-alt="Zapier"
    description="Event-driven workflow automation powered by Zapier."
    learn-more-link="https://zapier.com/apps/sera-systems/integrations"
    cy-selector="marketplaceZapier"
  >
    <template #configure>
      <div>
        <div
          v-if="zapierIntegrations.zapier.enabled"
          class="link"
          @click="toggleModal"
        >
          View & Copy API Key
        </div>
        <div v-else class="text-gray">View & Copy API Key</div>
      </div>
    </template>
    <template #modal>
      <div>
        <Modal
          v-if="modalOpen"
          title="Zapier Configuration API Key"
          class-name="zapier-config-modal"
          @hide-modal="toggleModal"
        >
          <template #submit>
            <Button @click="handleCopy">
              <span
                ><span v-if="!copied">Copy API Key</span
                ><span v-else>Copied to clipboard</span></span
              >
            </Button>
          </template>
          <div class="d-flex flex-column">
            <TextField
              v-model="zapierIntegrations.zapier.api_key"
              :readonly="true"
              class="full-width"
              label="API Key"
              name="api_key"
              placeholder="API Key"
              :validation-errors="v$.$errors"
            />
          </div>
        </Modal>
      </div>
    </template>
  </MarketplaceCard>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import TextField from "@/components/TextField.vue";
import ZapierLogo from "@/images/zapier_logo.png";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import MarketplaceCard from "./MarketplaceCard.vue";

export default {
  components: {
    MarketplaceCard,
    Modal,
    TextField,
    Button
  },
  data() {
    return {
      modalOpen: false,
      copied: false,
      initialEnabledValueLoaded: false
    };
  },
  computed: {
    ...mapState(["zapierIntegrations"]),
    imageUrl: {
      get() {
        return ZapierLogo;
      },
    },
  },
  watch: {
    "zapierIntegrations.zapier.enabled": function (newValue, oldValue) {
      if (!this.initialEnabledValueLoaded) {
        this.initialEnabledValueLoaded = true;
        return;
      }

      if (newValue !== oldValue) {
        this.updateEnabled();
      }
    }
  },
  mounted() {
    this.fetchZapierIntegrations();
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      zapierIntegrations: {
        zapier: {
          api_key: { required, $autoDirty: true }
        }
      }
    };
  },
  methods: {
    ...mapActions(["fetchZapierIntegrations", "updateZapierIntegrations"]),
    handleSave() {
      this.v$.$validate().then((valid) => {
        if (valid) {
          this.updateZapierIntegrations({
            zapierIntegrations: this.zapierIntegrations
          }).then(() => {
            window.notify.success("Zapier settings saved!");
            this.toggleModal();
          });
        }
      });
    },
    updateEnabled() {
      const en = this.zapierIntegrations.zapier.enabled;
      this.updateZapierIntegrations({
        zapierIntegrations: { zapier: { enabled: en } }
      }).then(() => {
        window.notify.success(`Zapier ${en ? "enabled" : "disabled"}!`);
      });
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    handleCopy() {
      navigator.clipboard
        .writeText(this.zapierIntegrations.zapier.api_key)
        .then(() => (this.copied = true));
    }
  }
};
</script>
